import { State } from 'store/state';

const getRandomInt = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const injectRandomNumber = (state: State) => {
  const randomNumber = getRandomInt(0, 1000);

  return {
    ...state,
    app: {
      ...state.app,
      randomNumber,
    },
  };
};
